import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";

const Legal = lazy(() => import("@/pages/Legal"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-[#030303]" />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/termos" element={<Legal kind="termos" />} />
            <Route path="/privacidade" element={<Legal kind="privacidade" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
